import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function Home() {
  const [selectedPackage, setSelectedPackage] = useState("");

  const handleSelect = (pkg) => {
    setSelectedPackage(pkg);
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="bg-ink text-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <Services onSelect={handleSelect} />
      <Booking selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />
      <Footer />
    </main>
  );
}
